
import GlassCard from "@/components/ui/glass-card";

const EmptyLeadState = () => {
  return (
    <GlassCard className="p-6 text-center">
      <div className="py-6">
        <div className="mb-4 text-muted-foreground">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-medium mb-2">No leads yet</h3>
        <p className="text-muted-foreground">
          Leads will appear here once you start receiving submissions
        </p>
      </div>
    </GlassCard>
  );
};

export default EmptyLeadState;
